<template>
<div class="page-wrapper">
	<div class="page page-members">
		<div class="container">
			<div class="page-header">
			</div>
			<div class="page-content">
				<!-- Large Loader -->
				<div class="wrapper-loader">
					<loader :align="'center'"/>
					<div class="ml-3">
						{{ textLoader }}
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
</template>

<script>
import Loader from '@/components/Loader.vue';
import {
	integrateShopee,
} from '@/api/marketplace-shopee';

export default {
	name: 'LoaderIntegrate',
	components: {
		Loader,
	},
	data() {
		return {
			isLoader: true,
			textLoader: this.$t('Please Wait For Your Account We Are Connecting'),
		};
	},
	methods: {
		integrateShopShopee() {
			const storeLabel = this.$route.query.store_label;
			const code = this.$route.query.code;
			const shopId = this.$route.query.shop_id;

			let valid = true;
			if (storeLabel === '' && code === '' && shopId === '') {
				valid = false;
			}

			const callback = (response) => {
				if (response.data) {
					this.$notify({
						group: 'app',
						type: 'success',
						title: this.$t('Omnichannel Shopee'),
						text: this.$t('Your account has been successfully linked'),
					});
					this.redirectSelfPage();
				}
			};
			const errorCallback = (e) => {
				if (e.response) {
					const response = e.response.data;
					const errorMessage = response.message;
					this.$notify({
						group: 'app',
						title: 'Omnichannel Shopee',
						type: 'error',
						text: errorMessage,
					});
					this.redirectSelfPage();
				}
			};
			if (valid) {
				const params = {
					storeLabel,
					code,
					shopId,
				};
				integrateShopee(params, callback, errorCallback);
			}
		},
		redirectSelfPage() {
			setTimeout(() => {
				this.$router.push('/settings/marketplace');
				// window.open('', '_self').close();
			}, 2000);
		},

	},
	computed: {
	},
	watch: {
	},
	created() {
		this.integrateShopShopee();
	},
};
</script>

<style lang="scss">
.page-content {
	.wrapper-loader {
		display: flex;
		position: absolute;
		z-index: 999;
		left: 0;
		right: 0;
		margin: 0 auto;
		height: calc(100% - 110px);
		align-items: center;
		justify-content: center;
		top: 0;
	}
}
</style>
